if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.blockId = this.dataset.blockId;
        this.block = this.closest(`[data-id="${this.blockId}"]`);
        this.section = this.closest('.section__wrapper');
        this.controls = this.section?.querySelector(`[data-controls-for="${this.blockId}"]`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableSwipeMobile = this.dataset.enableSwipeMobile === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.mobileItems = parseInt(this.dataset.mobileItems) || 1;
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider && !this.enableSwipeMobile) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.enableSwipeMobile ? this.initSlider() : this.destroySlider();
        } else {
          this.enableSlider ? this.initSlider() : this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
        const nextEl = this.controls?.querySelector(this.selectors.nextEl);
        const prevEl = this.controls?.querySelector(this.selectors.prevEl);
        const paginationEl = this.controls?.querySelector(this.selectors.pagination);

        this.sliderOptions = {
          slidesPerView: this.getMobileSlidesPerView(),
          spaceBetween: spaceBetween,
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 5,
          simulateTouch: true,
          allowTouchMove: true,
          touchEventsTarget: 'container',
          touchStartPreventDefault: false,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        if (nextEl && prevEl) {
          this.sliderOptions.navigation = {
            nextEl,
            prevEl,
          };
        }
        if (paginationEl) {
          this.sliderOptions.pagination = {
            el: paginationEl,
            type: this.paginationType,
          };
        }

        this.classList.add(this.classes.swiper);
        this.classList.remove('swipe-mobile');
        this.classList.remove(`swipe-mobile--${this.mobileItems}-cols`);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.remove('swipe-mobile__inner');
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderWrapper.querySelectorAll(':scope > .f-column').forEach((slide) => {
          slide.classList.add('swiper-slide');
        });

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        // const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        // focusableElements.forEach((element) => {
        //   element.addEventListener('focusin', () => {
        //     const slide = element.closest('.swiper-slide');
        //     this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
        //   });
        // });

        this.calcNavButtonsPosition();
        this.fixQuickviewDuplicate();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
        this.querySelectorAll(':scope > .swiper-button-prev, :scope > .swiper-button-next, :scope > .swiper-pagination').forEach(
          (element) => element.remove()
        );
        if (this.enableSwipeMobile) {
          this.classList.add('swipe-mobile');
          this.classList.add(`swipe-mobile--${this.mobileItems}-cols`);
          this.sliderWrapper.classList.add('swipe-mobile__inner');
        }
      }

      getMobileSlidesPerView() {
        if (this.mobileItems === 1) return 1.47;
        if (this.mobileItems === 2) return 2.38;
        if (this.mobileItems === 3) return 3.57;
        return this.mobileItems;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        const controls = this.controls;
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}
